module.exports = __webpack_public_path__ + "static/media/tela-passo-02.9a6b707c.jpg";